import { render, staticRenderFns } from "./ModalSubgrupoListNovo.vue?vue&type=template&id=2bf76d3b"
import script from "./ModalSubgrupoListNovo.vue?vue&type=script&lang=js"
export * from "./ModalSubgrupoListNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports